import React from "react";
import "./RedLineText.scss";

export default function RedLineText(props: any) {
  return (
    <div className={"font-body"}>
      <div className="border-l-4 pl-6 border-main">{props.TextContent}</div>
    </div>
  );
}
